import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { JobPosting } from "@/models/jobPosting";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbeddedJobPosting',
  props: {
  body: {
    type: Object as PropType<JobPosting>,
    default: null
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.body)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        key: 0,
        type: "application/ld+json"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.body.toLDJson()), 1)
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})